module.exports = __webpack_public_path__ + "img/perros.8e5e50e8.jpg";